// Type names exported from this package describe the WIRE shape — what
// a route actually returns over HTTP. Webapp internal types (e.g.
// `webapp/lib/projects/types.ts::Project`) can carry the same name for
// their in-process shape. When both are needed in one file, alias the
// webapp type on import:
//
//   import { Project } from "@ripenn/api-contracts";
//   import type { Project as DbProject } from "@/lib/projects/types";
//
// Don't rename contract exports to avoid the collision — the bare entity
// name is the canonical wire name and CLI commands prefer it unaliased.

export * from "./scan";
export * from "./project";
export * from "./brand";
export * from "./prompts";
export * from "./gap-content";
export * from "./analytics";
export * from "./integrations";
export * from "./edits";
export * from "./agents";
export * from "./internal";
export * from "./mcp-read-surface";
export * from "./content-review";
